var caseStudyTabComponent = (function () {
  var csComponentTabs = document.querySelectorAll(
      '.cs-tabs-style2-panel__list-item[role="tab"]'
    ),
    csComponentTabsUserDesignation = document.querySelectorAll(
      ".cs-tabs-style2-content__card-user-designation"
    ),
    csContentPanel = document.querySelectorAll(
      '.cs-tabs-style2-content__main[role="tabpanel"]'
    ),
    csComponentBullets = document.querySelectorAll(
      '.cs-tabs-style2-bullets__list-item[role="button"]'
    );
  csMainTabWrapper = document.querySelector(".cs-tabs-style2");
  csTabPanelWrapper = document.querySelector(".cs-tabs-style2_panel-wrapper");

  return {
    init: init,
  };

  function init() {
    if (csMainTabWrapper) {
      csMainTabWrapper
        .closest(".vc_row")
        .classList.add("cs-tabs-style2-section");
    }
    if (
      csComponentTabs.length &&
      csContentPanel.length &&
      csComponentBullets.length
    ) {
      //Tab child max height
      var tabContentSection = document.querySelectorAll(
          ".cs-tabs-style2-content__child"
        ),
        tabSectionMaxHeight = [];

      for (var j = 0; j < tabContentSection.length; j++) {
        tabSectionMaxHeight.push(tabContentSection[j].offsetHeight);
        if (j > 0) {
          tabContentSection[j]
            .closest("[data-href-target]")
            .classList.add("hide");
          tabContentSection[j]
            .closest("[data-href-target]")
            .classList.remove("cs-tabs-style2-content__temp");
        }
        tabContentSection[j].addEventListener("mouseenter", pauseSlider);

        tabContentSection[j].addEventListener("mouseleave", resumeSlider);
      }
      for (var k = 0; k < tabContentSection.length; k++) {
        tabContentSection[k].style.minHeight =
          Math.max.apply(Math, tabSectionMaxHeight) + "px"; // set max height
      }

      //Deisgnation min-height
      var designationDivMaxHeightarr = [];
      for (var d = 0; d < csComponentTabsUserDesignation.length; d++) {
        designationDivMaxHeightarr.push(
          csComponentTabsUserDesignation[d].offsetHeight
        );
      }
      for (var e = 0; e < csComponentTabsUserDesignation.length; e++) {
        csComponentTabsUserDesignation[e].style.minHeight =
          Math.max.apply(Math, designationDivMaxHeightarr) + "px";
      }

      var currentIndex = 0; // Keep track of the current active tab index

      // For easy reference
      var keys = {
        end: 35,
        home: 36,
        left: 37,
        up: 38,
        right: 39,
        down: 40,
        delete: 46,
        enter: 13,
        space: 32,
      };

      // Add or subtract depending on key pressed
      var direction = {
        37: -1,
        38: -1,
        39: 1,
        40: 1,
      };

      // Bind listeners on bullets for product component
      for (var b = 0; b < csComponentBullets.length; ++b) {
        setEventsOnCsComponentBullets(b);
      }

      function setEventsOnCsComponentBullets(index) {
        csComponentBullets[index].addEventListener(
          "click",
          setClickEvtOnCsComponentBullets
        );

        // Build an array with all tabs (<button>s) in it
        csComponentBullets[index].index = index;
      }
      // When a bullet is clicked, activateTab is fired to activate it
      function setClickEvtOnCsComponentBullets(event) {
        var bullet = event.target,
          bulletIndex = bullet.index,
          correspondingTab = csComponentTabs[bulletIndex];

        activateCsComponentTab(correspondingTab);
        setFocus(bullet);
        activateBullet(bullet);
        fireAmplitudeEvents(correspondingTab);
      }

      // Bind listeners on tabs for product component
      for (i = 0; i < csComponentTabs.length; ++i) {
        setEventsOnCsComponentTabs(i);
      }

      function setEventsOnCsComponentTabs(index) {
        csComponentTabs[index].addEventListener(
          "click",
          setClickEvtOnCsComponentTab
        );
        csComponentTabs[index].addEventListener(
          "keydown",
          setKeydownEvtOnCsComponentTab
        );
        csComponentTabs[index].addEventListener(
          "keyup",
          setKeyupEvtOnCsComponentTab
        );
        csComponentTabs[index].addEventListener("mouseover", loadImageOnHover);
        // Build an array with all tabs (<button>s) in it
        csComponentTabs[index].index = index;

        csComponentTabs[index].addEventListener("mouseenter", pauseSlider);

        csComponentTabs[index].addEventListener("mouseleave", resumeSlider);
      }
      // When a tab is clicked, activateTab is fired to activate it
      function setClickEvtOnCsComponentTab(event) {
        var tab = event.target,
          tabIndex = tab.index,
          correspondingBullet = csComponentBullets[tabIndex];
        activateCsComponentTab(tab);
        setFocus(tab);
        activateBullet(correspondingBullet);
        fireAmplitudeEvents(tab);
      }

      //activate corresponding bullet
      function activateBullet(bullet) {
        var activeBullet = document.querySelector(
          '.cs-tabs-style2-bullets__list-item[aria-selected="true"]'
        );
        if (activeBullet) {
          activeBullet.setAttribute("aria-selected", "false");
        }

        bullet.setAttribute("aria-selected", "true");
        bullet.setAttribute("tabindex", "-1");
        bullet.parentElement.classList.add(
          "cs-tabs-style2-bullets__list--active"
        );
      }

      // Handle keydown on Product tabs
      function setKeydownEvtOnCsComponentTab(event) {
        var key = event.keyCode;

        switch (key) {
          case keys.end:
            event.preventDefault();
            // Activate last tab
            focusCsComponentLastTab();
            break;
          case keys.home:
            event.preventDefault();
            // Activate first tab
            focusCsComponentFirstTab();
            break;
          default:
        }
      }

      // Handle keyup on Product tabs
      function setKeyupEvtOnCsComponentTab(event) {
        var key = event.keyCode;

        switch (key) {
          case keys.left:
          case keys.right:
            switchCsTabOnArrowPress(event);
            break;
          case keys.enter:
          case keys.space:
            var tab = event.target,
              tabIndex = tab.index,
              correspondingBullet = csComponentBullets[tabIndex];
            activateCsComponentTab(tab);
            setFocus(tab);
            activateBullet(correspondingBullet);
            break;
          default:
        }
      }
      // Either focus the next, previous, first, or last tab   depending on key pressed
      function switchCsTabOnArrowPress(event) {
        var pressed = event.keyCode;
        if (direction[pressed]) {
          var target = event.target;
          if (target.index !== undefined) {
            if (csComponentTabs[target.index + direction[pressed]]) {
              csComponentTabs[target.index + direction[pressed]].focus();
            } else if (pressed === keys.left || pressed === keys.up) {
              focusCsComponentLastTab();
            } else if (pressed === keys.right || pressed == keys.down) {
              focusCsComponentFirstTab();
            }
          }
        }
      }

      // Activates any given tab panel
      function activateCsComponentTab(tab) {
        // Deactivate all other tabs
        deactivateCsComponentTabs();

        // Remove tabindex attribute
        tab.removeAttribute("tabindex");

        // Set the tab as selected
        tab.setAttribute("aria-selected", "true");

        //set active to parent element
        tab.parentElement.classList.add("cs-tabs-style2-panel__list--active");

        //set current index to current active tab index
        currentIndex = tab.index;

        // Get the value of aria-controls (which is an ID)
        var panelControl = tab.getAttribute("aria-controls"),
          panelControlDom = document.getElementById(panelControl); // Remove hidden attribute from product panel to make it visible

        if (panelControlDom) {
          panelControlDom.setAttribute("aria-hidden", "false");
          panelControlDom.parentElement.classList.remove("hide");
        }

        //show images from lazy load
        loadImageOnHover();
      }

      function setFocus(tab) {
        tab.focus();
      }

      function fireAmplitudeEvents(tab) {
        currentIndex = tab.index;
        var tabAmpEventName = tab.getAttribute("data-tab-eventname"),
          tabAmpEventProperties = tab.getAttribute("data-tab-ampjson"),
          btnAmpJson;

        if (tabAmpEventName && tabAmpEventProperties) {
          btnAmpJson = bsLib.JSONParse(tabAmpEventProperties);
        }
        // Fire Amplitude Event on Tab click
        WebEventTracker.logEvent(EDS.webEvents, tabAmpEventName, btnAmpJson);
      }

      // Deactivate all tabs and tab panels
      function deactivateCsComponentTabs() {
        for (var j = 0; j < csComponentTabs.length; j++) {
          csComponentTabs[j].setAttribute("tabindex", "-1");
          csComponentTabs[j].setAttribute("aria-selected", "false");
          csComponentTabs[j].parentElement.classList.remove(
            "cs-tabs-style2-panel__list--active"
          );
        }

        for (var k = 0; k < csContentPanel.length; k++) {
          csContentPanel[k].setAttribute("aria-hidden", "true");
          csContentPanel[k].parentElement.classList.add("hide");
        }

        for (var l = 0; l < csComponentTabs.length; l++) {
          csComponentBullets[l].removeAttribute("tabindex", "-1");
          csComponentBullets[l].setAttribute("aria-selected", "false");
          csComponentBullets[l].parentElement.classList.remove(
            "cs-tabs-style2-bullets__list--active"
          );
        }
      }

      // Make a guess
      function focusCsComponentFirstTab() {
        csComponentTabs[0].focus();
      }

      // Make a guess
      function focusCsComponentLastTab() {
        csComponentTabs[csComponentTabs.length - 1].focus();
      }

      function loadImageOnHover() {
        //show images from lazy load
        lazyLoading.show();
      }

      var isPaused = false; // Variable to track if activation is paused

      function pauseSlider() {
        isPaused = true; // Pause the automatic activation
      }

      function resumeSlider() {
        isPaused = false; // Pause the automatic activation
      }

      // Function to activate the next tab after a delay
      function activateNextTab() {
        if (isPaused) {
          setTimeout(activateNextTab, 1000); // Check again after 1 second
          return;
        }
        currentIndex = (currentIndex + 1) % csComponentTabs.length; // Cycle through tabs
        var nextTab = csComponentTabs[currentIndex];

        activateCsComponentTab(nextTab); // Activate the next tab
        var correspondingBullet = csComponentBullets[currentIndex];
        activateBullet(correspondingBullet); // Activate the corresponding bullet

        setTimeout(activateNextTab, 5000); // Schedule the next activation after 3 seconds
      }

      // Start the automatic activation
      setTimeout(activateNextTab, 5000);
    }
    loadImageOnHover();
  }
})();

caseStudyTabComponent.init();
